var _g, _g2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCartBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 22.02 22.39",
    style: {
      enableBackground: "new 0 0 22.02 22.39"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "orderlist_2",
    transform: "translate(-1724.34 -40.686)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_1959",
    transform: "translate(0.549 -0.099)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rechteck_1220",
    d: "M1735.88,43.55h7c0.55,0,1,0.45,1,1l0,0c0,0.55-0.45,1-1,1h-7c-0.55,0-1-0.45-1-1l0,0 C1734.88,44,1735.33,43.55,1735.88,43.55z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vereinigungsmenge_8",
    d: "M1726.46,47.17l-1.41-1.42c-0.39-0.39-0.39-1.02,0-1.42c0.39-0.39,1.02-0.39,1.41,0l0.71,0.71 l3.12-3.12c0.37-0.41,1-0.44,1.41-0.07s0.44,1,0.07,1.41c-0.02,0.02-0.04,0.05-0.07,0.07l-3.83,3.83 C1727.49,47.56,1726.86,47.56,1726.46,47.17z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_1964",
    transform: "translate(0.549 7.73)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rechteck_1220-2",
    d: "M1735.88,42.55h7c0.55,0,1,0.45,1,1l0,0c0,0.55-0.45,1-1,1h-7c-0.55,0-1-0.45-1-1l0,0 C1734.88,43,1735.33,42.55,1735.88,42.55z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vereinigungsmenge_8-2",
    d: "M1726.46,46.17l-1.41-1.42c-0.39-0.39-0.39-1.02,0-1.42c0.39-0.39,1.02-0.39,1.41,0l0.71,0.71 l3.12-3.12c0.37-0.41,1-0.44,1.41-0.07s0.44,1,0.07,1.41c-0.02,0.02-0.04,0.05-0.07,0.07l-3.83,3.83 C1727.49,46.56,1726.86,46.56,1726.46,46.17z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_1963",
    transform: "translate(0 1.716)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Rechteck_1223",
    d: "M1736.43,56.15h7c0.55,0,1,0.45,1,1l0,0c0,0.55-0.45,1-1,1h-7c-0.55,0-1-0.45-1-1l0,0 C1735.43,56.6,1735.88,56.15,1736.43,56.15z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rechteck_1255",
    transform: "translate(1724.9 53.299)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M2.97,0.85h2c1.1,0,2,0.9,2,2v2c0,1.1-0.9,2-2,2h-2c-1.1,0-2-0.9-2-2v-2 C0.97,1.75,1.86,0.85,2.97,0.85z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 2
    },
    d: "M2.97,1.85h2c0.55,0,1,0.45,1,1v2c0,0.55-0.45,1-1,1h-2 c-0.55,0-1-0.45-1-1v-2C1.97,2.3,2.42,1.85,2.97,1.85z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCartBlack);
export default __webpack_public_path__ + "static/media/cartBlack.d2ac5026a31ff06ad72dad7ec258b02f.svg";
export { ForwardRef as ReactComponent };